var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"points"},_vm._l((_vm.points),function(p){return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ text: ((p.x) + ", " + (p.y)) }),expression:"{ text: `${p.x}, ${p.y}` }"}],key:p.created,staticClass:"point act",class:{ test: p.color === '?' },style:({
      width: ((_vm.getSize(p)) + "px"),
      height: ((_vm.getSize(p)) + "px"),
      backgroundColor: p.color,
      left: ((_vm.getX(p)) + "px"),
      top: ((_vm.getY(p)) + "px")
    }),attrs:{"id":p.created,"data-x":p.x,"data-y":p.y}})}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e55aee2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/UI/Grid/Points.vue
// module id = null
// module chunks = 